module.exports = __webpack_public_path__ + "static/media/wn2.a31c3de9.png";